import * as React from 'react';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import { Translate } from '../../../shared/LanguageService';
import FailureSnackbar from '../../../shared/feedback/FailureSnackbar';
import { UserPreferenceKeys } from '../../../shared/userPreferences/UserPreferencesApi';
import { useSaveUserPreferenceMutation } from '../../../shared/userPreferences/useSaveUserPreferenceMutation';
import { CreateOrderPageVersion } from './createOrderPageVersion';

type CreateOrderPageSwitchProps = {
    currentVersion: CreateOrderPageVersion;
};

export function CreateOrderPageSwitch({ currentVersion }: CreateOrderPageSwitchProps) {
    let saveUserPreference = useSaveUserPreferenceMutation();
    let [showFailed, setShowFailed] = React.useState(false);

    let isOnNewPage = currentVersion === 'v2';
    let textKey = isOnNewPage
        ? 'order/create/page-switch/back-to-old/text'
        : 'order/create/page-switch/try-new/text';
    let buttonKey = isOnNewPage
        ? 'order/create/page-switch/back-to-old/button'
        : 'order/create/page-switch/try-new/button';

    function switchPage() {
        saveUserPreference.mutate(
            { key: UserPreferenceKeys.CreateOrderPageVersion, value: isOnNewPage ? 'v1' : 'v2' },
            { onError: () => setShowFailed(true) }
        );
    }

    return (
        <>
            <Alert
                severity="info"
                sx={{ margin: '16px 0', alignItems: 'center', fontSize: '16px' }}
                action={
                    <Button
                        color="inherit"
                        size="small"
                        disabled={saveUserPreference.isLoading}
                        onClick={switchPage}
                    >
                        {Translate(buttonKey)}
                    </Button>
                }
            >
                {Translate(textKey)}
            </Alert>
            <FailureSnackbar
                open={showFailed}
                onClose={() => setShowFailed(false)}
                text={Translate('order/create/page-switch/save-failed')}
            />
        </>
    );
}
